// src/lib/sport-mismatch-copy.js -- #1652: what the importer says when the server refuses a
// screenshot because its legs are from a league other than the one the user chose.
//
// Single job: map the server's { kind, sport } (api/lib/vision-sport-check.js) to a heading and
// body. Reads: its argument. Writes: nothing. Unknown input returns null, so the caller keeps its
// generic error. Copy approved by Nicky 2026-10-24 (docs/audits/2026-10-24-1652-*).
const LABEL = Object.freeze({ nhl: 'NHL', mlb: 'MLB', nfl: 'NFL' });
const own = (o, k) => Object.prototype.hasOwnProperty.call(o, k);

export function sportMismatchCopy(refusal) {
  const kind = refusal?.kind;
  const sport = refusal?.sport;
  if (kind === 'untracked' && sport === 'nba') {
    return { heading: "NBA isn't tracked yet", body: 'SlipTrack tracks NHL, MLB and NFL bets. NBA support is coming.' };
  }
  if (kind === 'untracked' && sport === 'other') {
    return { heading: "This sport isn't tracked yet", body: 'SlipTrack tracks NHL, MLB and NFL bets.' };
  }
  if (kind === 'mixed_leagues' && typeof sport === 'string' && own(LABEL, sport)) {
    return { heading: "Parlays across leagues can't be imported yet", body: "Import each league's legs as its own slip." };
  }
  if (kind === 'other_league' && typeof sport === 'string' && own(LABEL, sport)) {
    return { heading: `This looks like an ${LABEL[sport]} slip`, body: `Switch the league to ${LABEL[sport]} and try again.` };
  }
  return null;
}
